<template>
  <div>

    <div v-if="loading">
      <loader></loader>
    </div>

    <!-- Fragmentos -->
    <modalTraceablePQComponentInHistory
      ref="modalTraceablePQComponentRef"
      :confirmAssigned="confirmActionTraceablePQ"
      :loading="loading"
    />

    <!-- Modal detalles -->
    <modalDetailsTraceablePQHistoryComponent
      :canCreateNotes="true"
    />

    <!-- Tabla para asignar producto -->
    <div>
      <!-- Informacion del producto -->
      <div class="row mb-1">
        <div class="col-12">
          <h4>{{ infoProducto.nombre }}</h4>
          <h6 class="text-muted">Sinónimos: {{ infoProducto.sinonimos }}</h6>
          <hr>
        </div>
        <div class="col-md-4">
          <p>
            <span class="font-weight-bold">No. Cas:</span> {{ infoProducto.cas }}
          </p>
        </div>
        <div class="col-md-4">
          <p>
            <span class="font-weight-bold">Uso:</span> {{ infoProducto.uso }}
          </p>
        </div>
        <div class="col-md-4">
          <p>
            <span class="font-weight-bold">Proveedor/Fabricante:</span> {{ infoProducto.fabricante ? infoProducto.fabricante.nombre : 'No registra' }}
          </p>
        </div>
      </div>
      <!-- Tabla de asignacion -->
      <div class="row">
        <div class="col-12 mb-1">
          <input class="form-control"
                 v-model="selectedBuscaEmpr.name"
                 placeholder="Filtrar por nombre de empresa"
                 @keyup="filtrar_empresas"
          />
          <b-form-checkbox v-model="asignadas"
                           class="pull-left"
                           @change="filtrar_empresas"
          >Solo empresas asignadas
          </b-form-checkbox>
          <p class="mt-0 mb-2 small text-right text-muted">
            {{ empresas_filtradas.length }} empresas encontradas
          </p>
        </div>
        <div class="col-12">
          <b-table
            id="tabla-empresas"
            striped
            hover
            small
            :items="empresas_filtradas"
            :fields="columnas"
            :per-page="items_por_pagina"
            :current-page="pagina_actual"
            bordered
          >
            <template v-slot:cell(asignado)="row" class="text-center">
              <b-form-checkbox
                :id="'assignment-'+row.item.id"
                :disabled="usuarioTecnico || row.item.is_blocked"
                v-model="row.item.asignado"
                @change="openModalToAssignProduct(row.item)"
              />
            </template>
            <template v-slot:cell(uso)="row" class="text-center">
              <b-form-checkbox
                :id="'use-'+row.item.id"
                v-if="row.item.asignado"
                :disabled="!row.item.asignado || row.item.is_blocked"
                v-model="row.item.in_use"
                @change="openModalToChangeUse(row.item)"
              />
            </template>

          <template v-slot:cell(notes)="row">
            <el-tooltip v-if="canSeeActionToComments && row.item.asignado" effect="dark" placement="top" content="Ver comentarios del producto." popper-class="py-1 px-2">
              <b-button variant="primary" size="sm" v-if="'productoEmpresa' in row.item && row.item.productoEmpresa" @click="onHandleShowModalToSeeDetails(row.item.productoEmpresa)">
                <i class="fa fa-commenting-o fa-lg text-white"></i>
              </b-button>
            </el-tooltip>
          </template>

          </b-table>
          <b-pagination
            class="mt-2 mb-0"
            v-model="pagina_actual"
            :total-rows="empresas_filtradas.length"
            :per-page="items_por_pagina"
            aria-controls="tabla-empresas"
            align="center"
            limit="10"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

// Componentes
import loader from '../../../containers/loader';
import modalTraceablePQComponentInHistory from './fragments/ModalTraceablePQ.vue'
import modalDetailsTraceablePQHistoryComponent from '../../history/assignPQ/fragments/ModalTraceablePQHistory.vue'

// Helpers
import { validarPermisoComponente } from '../../../plugins/acl';

export default {
    name: 'AsignacionProductos',
    props: ['IdProducto'],
    data: function () {
        return {
        items_por_pagina: 8,
        pagina_actual: 1,
        empresas_filtradas: [],
        asignadas: false,
        loading: false,
        columnas: [
            {
            key: "nombre",
            label: "Empresa",
            sortable: true,
            thStyle: { color: "#fff", background: "#097b83", width: "45%" },
            },
            {
            key: "asignado",
            label: "Asignado",
            sortable: false,
            thStyle: { color: "#fff", background: "#097b83", width: "10%" },
            },
            {
            key: "uso",
            label: "Disponible en el inventario",
            sortable: false,
            thStyle: { color: "#fff", background: "#097b83", width: "25%" },
            }
        ]
        };
    },
    components: {
        loader,
        modalTraceablePQComponentInHistory,
        modalDetailsTraceablePQHistoryComponent
    },
    computed: {
        ...mapState("asignacionproductos", ["selectedBuscaEmpr", "infoProducto"]),
        ...mapState("productos", ["rolProductos"]),
        ...mapState("autenticacion", ["usuarioTecnico", "usuarioAdmin"]),
        // Estados del modulo: trazabilidad de asignaciones y usos
        ...mapState('assignPQTraceable', [
            'dataModalTraceable',
            'actionToTraceablePQ',
            'traceable'
        ]),
        canSeeActionToComments() {
        return validarPermisoComponente('acciones-comentarios-productos');
        }
    },
  mounted() {
    this.filtrar_empresas();

    if (validarPermisoComponente('acciones-comentarios-productos')) {
      this.columnas.push({
        key: "notes",
        label: "Comentarios",
        sortable: false,
        thStyle: { color: "#fff", background: "#097b83", width: "15%" },
      });
    }
  },
  methods: {
    filtrar_empresas() {
      let filter = this.selectedBuscaEmpr.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

      if (this.asignadas) {
        this.empresas_filtradas = this.selectedBuscaEmpr.asignaciones.filter(empresa => {
          let nombre = empresa.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
          return nombre.includes(filter) && empresa.asignado;
        });
      } else {
        this.empresas_filtradas = this.selectedBuscaEmpr.asignaciones.filter(empresa => {
          let nombre = empresa.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
          return nombre.includes(filter);
        });
      }
    },
    /**
     * Abre el modal para agregar información sobre porque se realiza la acción (asignar/desasignar).
     *
     * @param {*} payload
     * @author Fernando Claros
     */
    openModalToAssignProduct(payload) {
      this.cancelLoadings();
      this.setActionToTraceablePQ({
        action: 'ASSIGNMENT',
        data: payload
      })
      this.$bvModal.show('modalTraceablePQComponent')
    },
    /**
     * Abre el modal para agregar información sobre porque se realiza la acción (uso/no-uso).
     *
     * @param {*} item
     * @author Fernando Claros
     */
    openModalToChangeUse(item) {
      this.cancelLoadings();
      this.setActionToTraceablePQ({
        action: 'USE',
        data: item
      })
      this.$bvModal.show('modalTraceablePQComponent')
    },
    cancelLoadings() {
      this.loading = false;
      this.setLoadingCancelProcess(false);
    },
    /**
     * Se confirma la acción desde el modal y se procesa la acción necesaria.
     *
     * @param Boolean isSuccess
     * @param Object payload
     * @param String|null comments
     * @author Fernando Claros
     */
    async confirmActionTraceablePQ(isSuccess, payload) {

        if (!isSuccess) {
            await this.getInfoAsignacion(this.IdProducto);
            this.filtrar_empresas();
            await this.getEmpresasAsig(this.IdProducto);

            this.$bvModal.hide('modalTraceablePQComponent');
            this.cancelLoadings();

            return false;
        }

        this.loading = true;

        if (payload.action === 'USE') {
            this.onHandleChangeUse({ ...payload.data, comments: this.traceable.comments, type: this.traceable.type });
            return false;
        }

        this.onHandleAssigned({ ...payload.data, comments: this.traceable.comments, type: this.traceable.type });
    },
    /**
     * Asignar/Desasignar.
     *
     * @param {*} data
     * @author Fernando Claros
     */
    async onHandleAssigned(data) {
      this.loading = true;
      await this.validaAsignacion(data);
      this.$bvModal.hide('modalTraceablePQComponent')
      this.filtrar_empresas();
      await this.getEmpresasAsig(this.IdProducto);
      this.loading = false;
    },
    /**
     * Usar/No usar.
     *
     * @param {*} data
     * @author Fernando Claros
     */
    async onHandleChangeUse(item) {
      const payload = {
        product_id: this.IdProducto,
        in_use: item.in_use,
        company_id: item.id,
        comments: item.comments,
        type: item.type
      };
      this.loading = true;
      await this.changeUseProductCompany(payload);
      this.$bvModal.hide('modalTraceablePQComponent')
      this.filtrar_empresas();
      await this.getEmpresasAsig(this.IdProducto);
      this.loading = false;
    },
    async traeAsignacion() {
      await this.getInfoAsignacion(this.IdProducto);
    },
    /**
     * Abre el modal para mostrar los detalles del histórico, tipo Notas/Comentarios.
     *
     * @param ?Object productCompany
     * @author Fernando Claros
     */
    async onHandleShowModalToSeeDetails(productCompany) {

      this.cancelLoadings();
      this.setActionToTraceablePQ({
        action: 'NOTA',
        data: null
      })

      this.setDataTraceable({
        assignId: productCompany.id,
        company_id: productCompany.id_empresa,
        product_id: productCompany.id_producto,
        product: {
          ...this.infoProducto,
          company: this.empresas_filtradas.find(x => x.id == productCompany.id_empresa)
        }
      });

      this.$bvModal.show('modalTraceablePQHistoryComponent')
      await this.getTraceableByCompanyAndAssignId({
        load: 'ALL',
        assignId: productCompany.id,
        company_id: productCompany.id_empresa,
        ...this.dataModalTraceable.table.data
      });
    },
    ...mapActions("asignacionproductos", [
      "guardaAsignacion",
      "getEmpresasList",
      "getInfoAsignacion",
      "validaAsignacion",
      "getEmpresasAsig",
      "getCamposPersonalizados",
      "changeUseProductCompany",
    ]),
    ...mapMutations('asignacionproductos', [
      'asignado',
      'setLoadingCancelProcess'
    ]),
    // Mutaciones para el modulo: trazabilidad de asignaciones y usos
    ...mapMutations('assignPQTraceable', [
      'setDataTraceable',
      'setActionToTraceablePQ'
    ]),
     // Acciones para el modulo: trazabilidad de asignaciones y usos
    ...mapActions('assignPQTraceable', [
      'getTraceableByCompanyAndAssignId'
    ]),
  }
};
</script>

<style>
.page-item.active .page-link {
  background-color: #097b83 !important;
  border-color: #097b83 !important;
}
</style>
